import { render, staticRenderFns } from "./BarInput.vue?vue&type=template&id=2f676d58&scoped=true&"
import script from "./BarInput.vue?vue&type=script&lang=ts&"
export * from "./BarInput.vue?vue&type=script&lang=ts&"
import style0 from "./BarInput.vue?vue&type=style&index=0&id=2f676d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f676d58",
  null
  
)

export default component.exports